import {useEffect} from "react";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import {ThemeProvider} from '@mui/material/styles';

import {getAnalytics, logEvent} from "firebase/analytics";

import ContactUs from "../components/ContactUs";
import MenuButton from "../components/MenuButton";
import Welcome from "../components/Welcome";
import Divider from "../../../components/common/Divider";

import {dizengoffMommiesTheme} from "../../../theme/theme";
import {Link} from "@mui/material";

function GiftCard() {
    useEffect(() => {
        logEvent(getAnalytics(), 'dizengoff_mommies');
    }, []);

    return (
        <ThemeProvider theme={dizengoffMommiesTheme}>
            <CssBaseline/>
            <Box
                display={"flex"}
                flexDirection={"column"}
                sx={{
                    width: "100%",
                    maxWidth: "100vw", // Prevents the Box from exceeding the viewport width
                    overflowX: "hidden",
                }}
            >
                <MenuButton/>
                <Welcome/>

                <Box
                    p={2}
                >
                    <Link
                        href="https://pay.grow.link/5b680289cf9e862ee54d9283eac968cf-MTkxODI2NA"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="none"
                        sx={{display: 'block'}} // ensures full clickable area
                    >
                        <Box
                            component="img"
                            src="/dizengoff_mommies/gift_card.png"
                            sx={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain"
                            }}
                        />
                    </Link>
                </Box>

                <Divider/>
                <ContactUs/>
            </Box>
        </ThemeProvider>
    );
}

export default GiftCard;
